<div class="back-button" (click)="closeSubMenu()">
  <app-icon iconStyle="fal" iconType="fa" iconName="angle-left"></app-icon>
  <app-icon iconStyle="far" iconType="fa" iconName="bars"></app-icon>
</div>
<ng-container *ngIf="isMemberMenu; else flatMenu">
  <div class="member-menu">
    <div class="member-menu__header">{{ menuTitle }}</div>
    <ng-container *ngFor="let group of currentItems; trackBy: trackByIndex">
      <ng-container *ngIf="group.hasChildren; else leafItem">
        <div class="member-menu__sub-header">{{ group.description }}</div>
        <ul class="member-menu__list">
          <li *ngFor="let child of group.children; trackBy: trackByIndex" class="member-menu__item">
            <a [routerLink]="child.path" routerLinkActive="member-menu__link--active" class="member-menu__link">
              {{ child.description }}
            </a>
          </li>
        </ul>
      </ng-container>
      <ng-template #leafItem>
        <ul class="member-menu__list">
          <li class="member-menu__item">
            <a [routerLink]="group.path" routerLinkActive="member-menu__link--active" class="member-menu__link">
              {{ group.description }}
            </a>
          </li>
        </ul>
      </ng-template>
    </ng-container>
  </div>
</ng-container>
<ng-template #flatMenu><p-menu [model]="currentMenuItems"></p-menu></ng-template>
